import type { InjectionKey, ComputedRef } from 'vue'

/** The ledger's default payment account id, provided to every account picker beneath it. */
export const FAVOURITE_ACCOUNT_KEY: InjectionKey<ComputedRef<string | undefined>> =
  Symbol('taler.favouriteAccount')

/** The item with `favouriteId` when it is offered and `selectable`, otherwise undefined. */
export function findFavourite<T extends { readonly id: string }>(
  items: readonly T[],
  favouriteId: string | undefined,
  selectable: (item: T) => boolean = () => true,
): T | undefined {
  if (favouriteId === undefined) return undefined
  const item = items.find((candidate) => candidate.id === favouriteId)
  return item !== undefined && selectable(item) ? item : undefined
}

/** Moves the favourite to the front; a list that does not offer it keeps its order. */
export function favouriteFirst<T extends { readonly id: string }>(
  items: readonly T[],
  favouriteId: string | undefined,
): readonly T[] {
  const favourite = findFavourite(items, favouriteId)
  return favourite === undefined ? items : [favourite, ...items.filter((item) => item !== favourite)]
}
